import React, { PureComponent } from 'react';
import InputRange from 'react-input-range';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import 'react-input-range/lib/css/index.css';
import './input-slider.scss';
import '../input-range/input-range.scss';

import type { Range } from 'react-input-range';

type Props = {
  minValue: number,
  maxValue: number,
  buttonStep: number,
  value: number,
  valueRange: Range,
  showButtons?: boolean,
  onChange: (value: number | Range) => void,
  highlighted?: boolean
};

class InputSlider extends PureComponent<Props> {
  static defaultProps = {
    buttonStep: 1
  };

  handleIncrease = () => {
    const { value, maxValue, buttonStep, onChange } = this.props;
    const newValue = Math.min(maxValue, value + buttonStep);

    onChange(newValue);
  };

  handleDecrease = () => {
    const { value, minValue, buttonStep, onChange } = this.props;
    const newValue = Math.max(minValue, value - buttonStep);

    onChange(newValue);
  };

  render() {
    const { value, showButtons, valueRange, highlighted, ...sliderProps } = this.props;

    const classes = classnames({
      'input-slider': true,
      'input-slider--highlighted': highlighted
    });

    return (
      <section className={classes}>
        {
          showButtons &&
            <div className="input-slider__button input-slider__button--minus">
              <SVGDynamicIcon
                name="minus-custom-fg"
                width="100%"
                height="100%"
                customColor="black"
                clickable
                onClick={this.handleDecrease}
              />
            </div>
        }
        <div className="input-slider__slider">
          <InputRange
            {...sliderProps}
            value={typeof valueRange === 'object' ? valueRange : value}
          />
        </div>
        {
          showButtons &&
            <div className="input-slider__button input-slider__button--plus">
              <SVGDynamicIcon
                name="plus-custom-fg"
                width="100%"
                height="100%"
                customColor="black"
                clickable
                onClick={this.handleIncrease}
              />
            </div>
        }
      </section>
    );
  }
}

export default InputSlider;
